<template>
  <v-dialog persistent v-model="openReportCommentThreadModel" max-width="400">
    <v-card>
      <v-card-title class="gc-text-h6">
        {{ lang.reports.AreThread }}
      </v-card-title>
      <v-card-text>
        {{ lang.reports.ThreadReport }}
      </v-card-text>
      <v-card-text>
        <v-form ref="commentThreadReport">
          <div class="input-group" style="width: 100%">
            <label>{{ lang.reports.ReportReason }} *</label>
            <select v-model="reportReason" class="custom-select">
              <option
                v-for="(report, ind) in reportCommentItems"
                :key="ind"
                :value="report.value"
              >
                {{ report.text }}
              </option>
            </select>
          </div>
          <div class="input-group mt-3" v-if="reportReason == 'Other'">
            <label>{{ lang.reports.OtherReason }} *</label>
            <textarea v-model="reportOther" rows="4"></textarea>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          elevation="0"
          small
          class="primary--text"
          @click="closeReportCommentThread()"
        >
          {{ lang.actions.cancel }}
        </v-btn>
        <v-btn
          small
          class="ml-2 btn-bg"
          elevation="0"
          @click="reportCommentThread()"
        >
          {{ lang.actions.report }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ReportCommentThreadDialog",
  data() {
    return {
      reportReason: "",
      reportOther: "",
    };
  },
  props: {
    openReportCommentThreadModel: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["rules"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    reportCommentItems() {
      return [
        {
          value: "Spam or promotional content",
          text: this.lang.reports.Reasons.spam,
        },
        {
          value: "Hate speech",
          text: this.lang.reports.Reasons.hateSpeech,
        },
        {
          value: "Harassment or bullying",
          text: this.lang.reports.Reasons.harassment,
        },
        {
          value: "Inappropriate language",
          text: this.lang.reports.Reasons.inappropriateLanguage,
        },
        {
          value: "Personal attacks",
          text: this.lang.reports.Reasons.personalAttacks,
        },
        {
          value: "Other",
          text: this.lang.reports.Reasons.other,
        },
      ];
    },
  },
  methods: {
    reportCommentThread() {
      if (
        (this.reportReason &&
          this.reportReason == "Other" &&
          this.reportOther) ||
        (this.reportReason && this.reportReason != "Other")
      ) {
        this.$emit("reportCommentThread", this.reportReason, this.reportOther);
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    closeReportCommentThread() {
      this.$emit("closeReportCommentThread");
    },
  },
};
</script>

